import $http from '../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Crear monitoreo general.
 * @param payload
 * @autor Paul Valencia
 */
export async function createGeneralMonitoring({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`general_monitoring`, payload);
        return response;
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: htmlErrors,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Crear monitoreo general.
 * @param payload
 * @autor Paul Valencia
 */
export async function destroyGeneralMonitoring({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.patch(`general_monitoring/${payload.id}/${payload.company_id}/destroy`);
        commit('deleteItemGeneralMonitorings', payload.id);
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: htmlErrors,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener informacion del módulo
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function getGeneralMonitorings({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`general_monitoring`, {params: {...payload}});
        commit('setDataGeneralMonitoring', response.data);
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: htmlErrors,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener informacion del módulo
 * @param payload: company_id, slq_location_id, type, description, file
 * @autor Paul Valencia
 */
export async function getDetailGeneralMonitorings({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`general_monitoring/${payload.id}/${payload.company_id}/details`);
        commit('setGrmDetail', response.data);
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: htmlErrors,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Crear monitoreo general.
 * @param payload
 * @autor Paul Valencia
 */
export async function updateGeneralMonitoring({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.put(`general_monitoring/${payload.id}/${payload.company_id}/update`, payload);
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });
    } catch (error) {
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Actualizar historial de seguimiento.
 * @param payload
 * @autor Paul Valencia
 */
export async function updateGrmHistorical({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`general_monitoring/${payload.get('id')}/${payload.get('company_id')}/update-historical`, payload);
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });
    } catch (error) {
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Descarga la imagen del adjunto.
 *
 * @param data: id, company_id
 * @autor Paul Valencia
 * @returns void
 */
export async function downloadFile({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: `grm_files/download_file`,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        const file = data.original_name;
        window.downloadFile(response.data, file)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontro el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}


/**
 * Cambiar el estado de un adjunto a inactivo para simular la eliminación.
 *
 * @param payload: id, company_id
 * @autor Paul Valencia
 * @returns company_id
 */
export async function deleteGrmFile(context, {id, company_id}) {
    await $http.patch(`grm_files/${id}/${company_id}/delete`, {company_id}).then(async (response) => {
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });

    }).catch(async (error) => {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    });
}


/**
 * Descarga la imagen para la previsualizacion.
 *
 * @param data
 * @autor Paul Valencia
 */
export async function getFileBase64({commit}, data) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http({
            url: `grm_files/download_file`,
            method: 'POST',
            responseType: 'blob',
            data
        })
        return response.data;
    } catch (e) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontro el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}



/**
 * Descargar reporte excel.
 * @param payload
 * @autor Paul Valencia
 */
export async function getGrmReportExcel({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: `general_monitoring_download_report`,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, `reporte_general_seguimiento${data.company_id}`, '.xlsx')
    })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al exportar los productos',
                showConfirmButton: true,
                timer: 5000
            });
        });
}




/**
 * Descargar plantilla para importar información de seguimiento
 * @param payload
 * @autor Paul Valencia
 */
export async function downloadFormatGrm({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: `general_monitoring_download_format`,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, `formato_importacion_seguimiento`, '.xlsx')
    })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al exportar los productos',
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/*
 * Cargar informacion en Excel
 *
 * @param commit
 * @param payload -> { file, company_id, slq_location_id, source_module}
 * @returns {Promise<void>}
 */
export async function uploadFileGrm({ commit }, payload) {

    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`general_monitoring_import_information`, payload);
        return response.data;
    } catch (error) {
        return Promise.reject(error.message)
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}



/**
 * Obtener data para graficas de seguimiento
 * @param payload
 * @autor Paul Valencia
 */
export async function geGrmInfoForGraphs({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`/general_monitoring_info_graphics`, { params: payload});
        commit('setInfoCharts',response.data.data)
        return response.data;
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

